export default "__VITE_ASSET__CgSisn1p__"